"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _nuiIntlRuntime = require("@concur/nui-intl-runtime");
var _reactRedux = require("react-redux");
var actions = _interopRequireWildcard(require("./listingModule"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var AutoConnectInput = function AutoConnectInput(_ref) {
  var listing = _ref.listing,
    isDisabled = _ref.isDisabled,
    updateLoyaltyNum = _ref.updateLoyaltyNum,
    formatter = _ref.formatter;
  var loyaltyNumber = listing.loyaltyNumber,
    ID = listing.ID;
  var handleFormUpdate = function handleFormUpdate(e) {
    updateLoyaltyNum(ID, e.target.value);
    updateLoyaltyNum(listing.core.v1ID, e.target.value);
  };
  var htmlMarkup = function htmlMarkup(html) {
    return {
      __html: html
    };
  };
  var renderLoyaltyInput = function renderLoyaltyInput() {
    if (!listing.core.triplinkLoyaltyNumber) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/_react.default.createElement("input", {
        style: {
          width: '100%'
        },
        type: "text",
        name: "loyaltyNumber",
        className: "form-control",
        disabled: isDisabled,
        "aria-label": formatter.formattedMessage({
          id: 'LoyaltyNumber1',
          values: {
            number: ''
          }
        }),
        placeholder: formatter.formattedMessage({
          id: 'LoyaltyNumber1',
          values: {
            number: ''
          }
        }),
        value: loyaltyNumber,
        onChange: handleFormUpdate
      }));
    }
    if (!listing.core.isConnectionPending) {
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h4", {
        dangerouslySetInnerHTML: htmlMarkup(formatter.formattedMessage({
          id: 'ExistingLoyaltyNum'
        }))
      }));
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h3", null, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "Connect"
  })), /*#__PURE__*/_react.default.createElement("br", null), !listing.core.triplinkLoyaltyNumber && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h4", null, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "AddLoyaltyNumber"
  })), /*#__PURE__*/_react.default.createElement("br", null)), renderLoyaltyInput());
};
AutoConnectInput.propTypes = {
  listing: _propTypes.default.shape({
    loyaltyNumber: _propTypes.default.string
  }),
  updateLoyaltyNum: _propTypes.default.func.isRequired,
  formatter: _propTypes.default.object
};
var _default = exports.default = (0, _reactRedux.connect)(null, {
  updateLoyaltyNum: actions.updateLoyaltyNum
})((0, _nuiIntlRuntime.withFormatter)(AutoConnectInput));